import {
  Coverage,
  Term,
  TermOption,
} from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { TFunction } from 'i18next';
import { CoverageOptions } from '../Coverage.type';
import { WithRequired, isDefined } from '../utils/type.utils';

const isTermOption = (
  item: TermOption,
): item is WithRequired<TermOption, 'code' | 'name'> => !!(item.code && item.name);

const getChosenTermValue = (coverageTerm: Term | undefined, t: TFunction): string | undefined => {
  if (isDefined(coverageTerm) && Number(coverageTerm.chosenTermValue)) {
    return coverageTerm.chosenTermValue;
  }

  const coverageOption = coverageTerm?.options?.find((option) => option.code === coverageTerm.chosenTerm);

  if (coverageOption && isTermOption(coverageOption)) {
    return t(`${coverageOption.name}`);
  }

  return undefined;
};

export const getCoverageOptions = (
  coverage: Coverage,
  t: TFunction,
): {
  chosenTermValue?: string;
  options?: CoverageOptions[];
} => {
  const coverageOptions = coverage.terms?.[0]?.options;
  const chosenTermValue = getChosenTermValue(coverage.terms?.[0], t);

  const options = coverageOptions?.filter(isTermOption)
    .map((option) => ({
      price: option.optionValue ?? 0,
      value: option.code,
      label: option.name,
    }))
    .sort((prevOption, nextOption) => prevOption.price - nextOption.price);

  return { options, chosenTermValue };
};
